import { render, staticRenderFns } from "./ReportPhysicianFirstAdvance.vue?vue&type=template&id=66508756&scoped=true&"
import script from "./ReportPhysicianFirstAdvance.vue?vue&type=script&lang=js&"
export * from "./ReportPhysicianFirstAdvance.vue?vue&type=script&lang=js&"
import style0 from "./ReportPhysicianFirstAdvance.vue?vue&type=style&index=0&id=66508756&lang=scss&scoped=true&"
import style1 from "./ReportPhysicianFirstAdvance.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66508756",
  null
  
)

export default component.exports